import { DialogTitle } from '@talentmesh/ui/components/dialog';
import UIStrings from '@/Utils/UIStrings';

const AssessmentResetDialogHeader = () => {
    return <DialogTitle>{UIStrings.ResetAssessment}</DialogTitle>;
};

export default AssessmentResetDialogHeader;
